import {computed, PropType} from "vue";
import {PageDataHolderFetchedWidget} from "../../lib/interfaces/model/PageDataHolderFetchedWidget";
import {MenuItem} from "../../lib/models/MenuItem";
import {useTyrionMasterPage} from "../master_page";
import {Widget} from "../../lib/interfaces/model/Widget";

export function useWidget(widget: PageDataHolderFetchedWidget) {


    const content = computed<Array<MenuItem>>(() => widget.content.map((t: { [k: string]: any }) => (new MenuItem()).fromObject(t)));

    return {content: content.value as Array<MenuItem>, widgetData: widget.widget as Widget, masterPage: useTyrionMasterPage()};
}
